module.exports = __webpack_public_path__ + "static/media/map_default.896e63c7.jpg";